import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IApiUpdateAddressInput, IApiUpdateInvestigationInput } from 'src/app/shared/modules/graphql/types/types';

@Component({
  selector: 'app-calendar-conflict-check',
  templateUrl: './calendar-conflict-check.component.html',
  styleUrls: ['./calendar-conflict-check.component.scss']
})
export class CalendarConflictCheckComponent implements OnInit {
  public proximityAddress: IApiUpdateAddressInput | null = null;
  public markers: [number, number, string][] = [];
  public selectedInvestigationId: string = '';
  public tableInput: IApiUpdateInvestigationInput | null = null;

  constructor(private route: ActivatedRoute, private router: Router) { }

  ngOnInit(): void {
    const params = this.route.snapshot.queryParams;
    if (params.address && params.lat && params.lng) {
      this.proximityAddress = {
        address1: params.address,
        formatted_address: params.address,
        latitude: parseFloat(params.lat),
        longitude: parseFloat(params.lng),
        id: ''
      } as any;
      this.onApply();
    }
  }

  public onAddressSelected(address: any): void {
    this.proximityAddress = address;
    this.updateUrlParams();
  }

  private updateUrlParams(): void {
    const queryParams: any = {};
    if (this.proximityAddress) {
      queryParams.address = (this.proximityAddress as any).formatted_address || this.proximityAddress.address1;
      queryParams.lat = this.proximityAddress.latitude;
      queryParams.lng = this.proximityAddress.longitude;
    } else {
      queryParams.address = null;
      queryParams.lat = null;
      queryParams.lng = null;
    }

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams,
      queryParamsHandling: 'merge',
    });
  }

  public onApply(): void {
    if (this.proximityAddress && this.proximityAddress.latitude && this.proximityAddress.longitude) {
      this.tableInput = {
        id: '', // Mock ID for search
        LossAddress: this.proximityAddress
      } as IApiUpdateInvestigationInput;
    } else {
      this.tableInput = null;
      this.markers = [];
    }
  }

  public onClear(): void {
    this.proximityAddress = null;
    this.tableInput = null;
    this.markers = [];
    this.selectedInvestigationId = '';
    this.updateUrlParams();
  }
}
